import { render, staticRenderFns } from "./MoreOptions.vue?vue&type=template&id=eddb4dec"
import script from "./MoreOptions.vue?vue&type=script&lang=js"
export * from "./MoreOptions.vue?vue&type=script&lang=js"
import style0 from "./MoreOptions.vue?vue&type=style&index=0&id=eddb4dec&prod&lang=scss&s=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports